import Handler from "../Handler";
class NextGameRequestHandler extends Handler {
  execute() {
    this.service.processNextGameRequest();
  }
}

export default NextGameRequestHandler;
